import Vue from 'vue';
import NProgress from 'nprogress';
import APlayer from '@moefe/vue-aplayer';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';

Object.defineProperty(Vue.prototype, '$NProgress', { value: NProgress });
Vue.config.productionTip = false;

Vue.prototype.$appName = 'Ragya';
Vue.use(APlayer, {
  defaultCover: '/img/singer.png',
  productionTip: true,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
